import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateChannel } from "../schemas/schemas_0";
export { $Command };
export class UpdateChannelCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "UpdateChannel", {})
    .n("ChimeSDKMessagingClient", "UpdateChannelCommand")
    .sc(UpdateChannel)
    .build() {
}
